<template>
  <div class="study-particip-details-block pt-10 pl-0" :class="{ 'telehealth-call': telehealthCallStatus }">
    <div class="nav-breadcrumb pt-10 pl-4">
      <NavigationBreadcrumb :navigationWidth="navigationWidth" @toggleParticipant="toggleParticipant" :navigationOptions="navigationOptions"></NavigationBreadcrumb>
    </div>
    <div class="clear-float"></div>
    <PiiAndNonPiiInfo class="clear-both" v-if="participantInfo" :studyData="studyData" :participantDetails="participantInfo" @expanded="piInfoExpanded"></PiiAndNonPiiInfo>
    <b-row class="mt-4" id="edcFormDetail">
      <b-col cols="12" class="p-0">
        <ParticipantInfo :areActionsAllowed="areActionsAllowed" :participantDetails="participantInfo" :activityForm="unscheduledForms[currentFormIndex] && unscheduledForms[currentFormIndex].form.activity" :selectedLanguageCulture="selectedLanguageCulture" @onLanguageChange="onLanguageChange" :languages="languages" />
      </b-col>
      <b-col cols="12" class="pl-0 pr-0" v-if="unscheduledForms.length > 0">
        <b-row class="mb-20">
          <div class="primaryBackGround">
            <div>
              <div class="pt-20 pr-20 pl-30 m-0">
                <span class="fs-14">{{ packetName }}</span> /
                <b-dropdown v-if="unscheduledForms[currentFormIndex]" id="dropdown-1" :text="unscheduledForms[currentFormIndex].form.name">
                  <b-dropdown-item v-for="(unscheduleForm, index) in unscheduledForms" :key="unscheduleForm.id" @click="navigateToOtherFormInAPacket(index)">{{ unscheduleForm.form.name }}</b-dropdown-item>
                </b-dropdown>
              </div>
              <b-col v-if="unscheduledForms[currentFormIndex] && unscheduledForms[currentFormIndex].form.type != 'EDC' && unscheduledForms[currentFormIndex].form.activity && unscheduledForms[currentFormIndex].form.activity.customClinRO && unscheduledForms[currentFormIndex].form.activity.customView === 'CSSRS_BASELINE'" cols="12 p-0">
                <ActivityFormCustomClinro
                  :activityFormData="unscheduledForms[currentFormIndex].form"
                  :formName="unscheduledForms[currentFormIndex].form.name"
                  :formSubmitted="formSubmitted"
                  @disabledFields="disabledFields"
                  :studyId="studyId"
                  :mode="'EDIT'"
                  ref="activityFormPreview"
                  id="clinro-c-ssr-form"
                  :lang="selectedLanguageCulture == 'KO' || selectedLanguageCulture == 'PL' ? selectedLanguageCulture.toLowerCase() : selectedLanguageCulture"
                />
              </b-col>
              <b-col v-else-if="unscheduledForms[currentFormIndex] && unscheduledForms[currentFormIndex].form.type != 'EDC' && unscheduledForms[currentFormIndex].form.activity && unscheduledForms[currentFormIndex].form.activity.customClinRO && unscheduledForms[currentFormIndex].form.activity.customView === 'CSSRS_SINCE_LAST'" cols="12 p-0">
                <CustomClinroSinceLastVisit
                  :activityFormData="unscheduledForms[currentFormIndex].form"
                  :formName="unscheduledForms[currentFormIndex].form.name"
                  :studyId="studyId"
                  :formSubmitted="formSubmitted"
                  @disabledFields="disabledFields"
                  :mode="'EDIT'"
                  ref="activityFormPreview"
                  id="clinro-c-ssr-form"
                  :lang="selectedLanguageCulture == 'KO' || selectedLanguageCulture == 'PL' ? selectedLanguageCulture.toLowerCase() : selectedLanguageCulture"
                />
              </b-col>
              <b-col v-else-if="unscheduledForms[currentFormIndex].form.type != 'EDC'" cols="12">
                <ActivityFormPreview
                  v-if="showActivity"
                  :key="unscheduledForms[currentFormIndex].form.id"
                  :activityFormData="unscheduledForms[currentFormIndex].form"
                  :formName="unscheduledForms[currentFormIndex].form.name"
                  :formSubmitted="formSubmitted"
                  :trigger-validation="triggerValidation"
                  @getQuestionScores="validateDataForScoring"
                  :mode="currentFormPermission.canCompleteActivity ? 'EDIT' : 'PREVIEW'"
                  :lang="languageCulture"
                  @disabledFields="disabledFields"
                  ref="activityFormPreview"
                  :showBanner="true"
                  :createdById="createdById"
                  :showValidationMessage="showValidationMessage"
                  @onValidateAnswer="onValidateAnswer"
                  :validationCount="validationCount"
                />
                <div v-else class="mx-3 my-5">
                  <b-alert variant="danger" show>You do not have the permission to view {{ unscheduledForms[currentFormIndex].form.name }}.</b-alert>
                </div>
              </b-col>
              <b-col v-else cols="12">
                <FormPreview :formData="unscheduledForms[currentFormIndex].form.fields" :formSubmitted="formSubmitted" />
              </b-col>
            </div>
            <div class="pt-40 mr-40 d-flex justify-content-end" v-if="displayMobileView === false && showActivity">
              <b-btn size="sm" class="fs-14 mr-15" variant="outline-secondary" @click="cancelForm">Cancel</b-btn>
              <b-btn size="sm" class="fs-14 mr-15" variant="outline-primary" @click="validateDataAndSave('DRAFT')" :disabled="canCraAccess || canDmAccess || canSiteDataLockAccess || user.readOnly || buttonClicked || !currentFormPermission.canCompleteActivity || userIsStudyAdmin || canCraUBAccess">Save as Pending</b-btn>
              <b-btn size="sm" class="fs-14 primaryBgColor" variant="primary" v-if="currentFormIndex === unscheduledForms.length - 1" @click="validateDataAndSave('SUBMITTED')" :disabled="canCraAccess || canDmAccess || canSiteDataLockAccess || user.readOnly || buttonClicked || !currentFormPermission.canCompleteActivity || userIsStudyAdmin || canCraUBAccess">Complete</b-btn>
              <b-btn size="sm" class="fs-14 primaryBgColor" variant="primary" v-else @click="checkErrors()" :disabled="canCraAccess || canDmAccess || canSiteDataLockAccess || user.readOnly || userIsStudyAdmin || buttonClicked || canCraUBAccess">Next Form</b-btn>
            </div>
            <div class="d-flex ml-5 center-align-item" v-if="displayMobileView === true && showActivity">
              <b-btn size="sm" class="fs-14 mr-15 btn-1" variant="outline-secondary" @click="cancelForm">Cancel</b-btn>
              <b-btn size="sm" class="fs-14 mr-15 btn-1" variant="outline-primary" @click="validateDataAndSave('DRAFT')" :disabled="canCraAccess || canDmAccess || canSiteDataLockAccess || user.readOnly || buttonClicked || !currentFormPermission.canCompleteActivity || userIsStudyAdmin || canCraUBAccess">Save as Pending</b-btn>
              <b-btn size="sm" class="fs-14 primaryBgColor btn-1" variant="primary" v-if="currentFormIndex === unscheduledForms.length - 1" @click="validateDataAndSave('SUBMITTED')" :disabled="canCraAccess || canDmAccess || canSiteDataLockAccess || user.readOnly || buttonClicked || !currentFormPermission.canCompleteActivity || userIsStudyAdmin || canCraUBAccess">Complete</b-btn>
              <b-btn size="sm" class="fs-14 primaryBgColor btn-1" variant="primary" v-else @click="checkErrors()" :disabled="canCraAccess || canDmAccess || canSiteDataLockAccess || user.readOnly || userIsStudyAdmin || buttonClicked || canCraUBAccess">Next Form</b-btn>
            </div>
          </div>
        </b-row>
        <b-row></b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import * as activityService from "@/components/services/activity-service";
import find from "lodash/find";
import sortBy from "lodash/sortBy";
import findIndex from "lodash/findIndex";
import difference from "lodash/difference";
import uniq from "lodash/uniq";
import pull from "lodash/pull";
import isEmpty from "lodash/isEmpty";
import _ from "lodash";
import { AclRule } from "vue-acl";
import { mapActions, mapGetters } from "vuex";
import { CRA, DM, SITEDATALOCK, CraUB, SUPPORT, STUDY_ADMIN } from "@/constants/authRoles";
import * as constant from "@/constants/config";
import ParticipantInfo from "@/components/participants/participant-info-new";
import FormPreview from "../../components/edc-form/form-preview";
import NavigationBreadcrumb from "@/components/common/navigation-breadcrumb";
import PiiAndNonPiiInfo from "@/components/participants/pii-and-non-pii-info";
import ActivityFormPreview from "@/components/activity-form/activity-form-preview-columns";
import ActivityFormCustomClinro from "@/components/activity-form/activity-form-custom-clinro";
import CustomClinroSinceLastVisit from "@/components/activity-form/activity-form-custom-clinro/custom-clinro-since-last-visit";
import * as customClinroService from "@/components/services/custom-clinro-branching";
import MultilingualService from "@/components/services/multilingual-service";

export default {
  name: "Form-view",
  data() {
    return {
      milestone: Number(this.$route.params.milestone),
      showActivity: true,
      unansweredQuestions: [],
      formSubmitted: 1,
      packetId: this.$route.params.packetId,
      studyId: this.$route.params.studyId,
      participantId: this.$route.params.participantId,
      unscheduledPacketResponseId: this.$route.params.unscheduledPacketResponseId,
      responseType: this.$route.params.responseType,
      unscheduledForms: [],
      formsDisabledFields: [],
      selectedPacket: null,
      formData: [],
      saveType: "",
      formResponses: {},
      currentFormPermission: {},
      participantInfo: {},
      responses: [],
      currentFormResoponse: [],
      alreadySavedUnscheduleForms: [],
      formSaveResponse: {},
      formErrors: [],
      responseScores: [],
      navigationOptions: [
        {
          name: "Profile",
          isLink: true,
          route: "participant-profile",
          params: { studyId: this.$route.params.studyId },
          displayOrder: 2
        },
        {
          name: "Participants",
          isLink: true,
          route: "study-participants-list",
          params: { studyId: this.$route.params.studyId },
          displayOrder: 1
        },
        {
          name: "Packet Details",
          isLink: false,
          route: null,
          params: null,
          displayOrder: 3
        }
      ],
      packetName: null,
      areActionsAllowed: {
        document: false,
        telehealth: true,
        edcforms: false,
        approval: false,
        verifyBtn: false,
        send: false,
        sign: false,
        print: false
      },
      navigationWidth: "62%",
      telehealthCallStatus: false,
      buttonClicked: false,
      currentFormIndex: 0,
      disabledFieldsByBranchingLogic: {},
      displayMobileView: Boolean,
      createdById: "",
      validateCSSRFormErros: null,
      selectedLanguageCulture: "EN",
      mlService: new MultilingualService(this.$route),
      triggerValidation: false,
      isSubmit: false,
      unsupportedQuestionType: ["ImageCapture", "MedicationSelector", "AudioRecording", "SurveyCompletion", "SurveyInstruction", "VideoRecording", "GPSkin", "Section", "WongBaker"],
      taskInstanceId: this.$route.params.taskInstanceId,
      showValidationMessage: false,
      validationCount: 0
    };
  },
  created() {
    if (constant.SCREENWIDTH > 1200) {
      this.displayMobileView = false;
    } else {
      this.displayMobileView = true;
    }
  },
  components: {
    FormPreview,
    ParticipantInfo,
    NavigationBreadcrumb,
    PiiAndNonPiiInfo,
    ActivityFormPreview,
    ActivityFormCustomClinro,
    CustomClinroSinceLastVisit
  },
  methods: {
    onLanguageChange(lang) {
      this.selectedLanguageCulture = lang;
      for (let index = 0; index < this.languages.length; index++) {
        if (lang == this.languages[index].language_culture) {
          this.selectedLanguageId = this.languages[index].language_id;
          this.getApplangaData(this.languages[index].language_id);
        }
      }
    },
    getApplangaData(languageId) {
      this.$nextTick(() => {
        this.mlService.getCSSRTranslation(this.$route.params.studyId, languageId);
      });
    },
    ...mapActions(["clearEDCFormErrors"]),
    disabledFields(fields, clear = false) {
      this.unscheduledForms[this.currentFormIndex][this.disabledFieldsByBranchingLogic] = _.cloneDeep(fields);
      this.formsDisabledFields[this.currentFormIndex] = fields;
      if (clear) {
        this.validationCount = this.validationCount + 1;
      }
    },
    letMakeOptionalToDisableFields(requiredFieldIds, formIndex) {
      const fieldsDisabled = [];
      if (this.formsDisabledFields && this.formsDisabledFields[formIndex]) {
        for (const [o, i] of Object.entries(this.formsDisabledFields[formIndex])) {
          if (i == true) {
            fieldsDisabled.push(o);
          }
        }
      }
      return difference(requiredFieldIds, fieldsDisabled);
    },
    closeModal(ref) {
      this.$refs[ref].hide();
    },
    piInfoExpanded(isExpanded) {
      const c = document.getElementById("edcFromDetail");
      if (isExpanded) {
        setTimeout(() => {
          window.$("#edcFromDetail").animate({});
        }, 400);
      } else {
        c.style.paddingTop = "0px";
      }
    },
    // get the participant details
    getParticipantDetails() {
      this.$api.getParticipantDataFactV2(this.studyId, this.participantId).then(
        response => {
          this.participantInfo = response.body;
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participant.");
        }
      );
    },
    // get the unscheduled packets details
    getEDCUnscheduledPacketForms() {
      this.$api
        .getUnscheduledPacketFact(this.studyId, this.packetId)
        .then(packetResponse => {
          this.selectedPacket = packetResponse.body;
          if (packetResponse && packetResponse.body && packetResponse.body.name) {
            this.packetName = packetResponse.body.name;
          }
          // !== '0' means existing packet
          if (this.unscheduledPacketResponseId !== "0") {
            this.$api.getUnscheduleFormResponseFactV3(this.studyId, this.participantId, this.packetId, this.unscheduledPacketResponseId).then(response => {
              this.alreadySavedUnscheduleForms = response.body;
              let formIndex = 0;
              if (response.body.responseVersionCreatedBy) {
                this.createdById = response.body.responseVersionCreatedBy;
              }
              this.alreadySavedUnscheduleForms.packetFormResponses.forEach(result => {
                this.formResponses = result.response;
                this.formResponses.state = result.response.state;
                this.formData = result.form;
                // send the saved answers to the corresponding form components
                if (this.formData.type == "EDC") {
                  if (this.formResponses && this.formResponses.answers && this.formResponses.answers.length) {
                    // loop through the available answers
                    this.formResponses.answers.forEach(answer => {
                      // get the field index in the saved formData using answer question ID
                      const selectedFieldIndex = findIndex(this.formData.fields, ["id", answer.questionId]);
                      // get the option which is saved as answer using option ID
                      const selectedOption = find(this.formData.fields[selectedFieldIndex].options, ["id", answer.optionId]);
                      // get index of the option in options array
                      // which is saved as answer using optionnId
                      const selectedOptionIndex = findIndex(this.formData.fields[selectedFieldIndex].options, ["id", answer.optionId]);
                      // In formData attach answer as well as the comment
                      // if the comment message is saved
                      this.formData.fields[selectedFieldIndex].answer = answer.answerText;
                      // for singlechoice the answer which is saved
                      // need's to be modified as per preview
                      if (this.formData.fields[selectedFieldIndex].name === "formSinglechoice" || this.formData.fields[selectedFieldIndex].name === "formDropdown") {
                        this.formData.fields[selectedFieldIndex].answer = answer.optionId;
                      }
                      if (this.formData.fields[selectedFieldIndex].name === "formScale") {
                        const selectedScaleOption = find(this.formData.fields[selectedFieldIndex].options, ["id", answer.optionId]);
                        if (selectedScaleOption.type === "NA" || selectedScaleOption.type === "Other") {
                          this.formData.fields[selectedFieldIndex].nonScaleAnswer = answer.answerText;
                          this.formData.fields[selectedFieldIndex].answer = null;
                        }
                      }
                      if (selectedOption && selectedOption.type === "Other" && selectedOption.commentField) {
                        this.formData.fields[selectedFieldIndex].options[selectedOptionIndex].comment.commentMessage = answer.comment;
                      }
                      // for checkBox the options array which is saved
                      // need's to be modified as per preview
                      const tempOptions = [];
                      if (this.formData.fields[selectedFieldIndex].name === "formCheckbox") {
                        this.formData.fields[selectedFieldIndex].options.forEach((option, index) => {
                          const tempOption = option;
                          tempOption.answer = {
                            unSelected: `${index + 1}`
                          };
                          tempOption.value = option.label;
                          tempOption.selectVal = `${index + 1}`;
                          tempOptions.push(option);
                        });
                        answer.multiAnswer.forEach(ans => {
                          tempOptions[ans.index].answer = {
                            selected: tempOptions[ans.index].selectVal
                          };
                          if (tempOptions[ans.index].type === "Other" && tempOptions[ans.index].commentField) {
                            tempOptions[ans.index].comment.commentMessage = ans.comment;
                          }
                        });
                        this.formData.fields[selectedFieldIndex].options = tempOptions;
                      }
                      if (this.formData.fields[selectedFieldIndex].name === "formDateTime") {
                        if (answer.time) {
                          if (this.formData.fields[selectedFieldIndex].timeField.format === "hh:mm a") {
                            const timeVals = answer.time.split(" ");
                            const time = timeVals[0].split(":");
                            this.formData.fields[selectedFieldIndex].time = {
                              hh: time[0],
                              mm: time[1]
                            };
                            this.formData.fields[selectedFieldIndex].meridian = timeVals[1] || null;
                          } else if (this.formData.fields[selectedFieldIndex].timeField.format === "HH:mm") {
                            const time = answer.time.split(":");
                            this.formData.fields[selectedFieldIndex].time = {
                              HH: time[0],
                              mm: time[1]
                            };
                          }
                          this.formData.fields[selectedFieldIndex].timezone = answer.timezone;
                        }
                        if (answer.date) {
                          const dateVals = answer.date.split("/");
                          const dateFormat = pull(uniq(this.formData.fields[selectedFieldIndex].dateField.format), "/");
                          dateFormat.forEach((value, index) => {
                            if (value === "M") {
                              this.formData.fields[selectedFieldIndex].month = dateVals[index];
                            }
                            if (value === "D") {
                              this.formData.fields[selectedFieldIndex].date = dateVals[index];
                            }
                            if (value === "Y") {
                              this.formData.fields[selectedFieldIndex].year = dateVals[index];
                            }
                          });
                        }
                      }
                      // for table the fields array which is saved need's
                      // to be modified as per preview
                      const tempTableOptions = [];
                      if (this.formData.fields[selectedFieldIndex].name === "formTable") {
                        // for the available fields add the answer which are configured
                        // at form creation
                        if (this.formData.fields[selectedFieldIndex].noOfFields) {
                          for (let ind = 0; ind < this.formData.fields[selectedFieldIndex].noOfFields; ind++) {
                            tempTableOptions.push({
                              index: ind,
                              type: "OPTION",
                              label: ""
                            });
                          }
                        }
                        // Add the answer to fields which are not configured
                        // while form creation but added by user
                        const tempTableUserOptions = [];
                        if (answer.multiAnswer.length > this.formData.fields[selectedFieldIndex].noOfFields) {
                          for (let ind = this.formData.fields[selectedFieldIndex].noOfFields; ind < answer.multiAnswer.length; ind++) {
                            tempTableUserOptions.push({
                              index: ind,
                              type: "OPTION",
                              label: ""
                            });
                          }
                        }

                        // attach answers to the generated fields and user added fields
                        answer.multiAnswer.forEach((ans, index) => {
                          if (index < this.formData.fields[selectedFieldIndex].noOfFields) {
                            tempTableOptions[index].label = ans.answerText;
                          }
                          if (index >= this.formData.fields[selectedFieldIndex].noOfFields) {
                            tempTableUserOptions[index - this.formData.fields[selectedFieldIndex].noOfFields].label = ans.answerText;
                          }
                        });
                        this.formData.fields[selectedFieldIndex].fields = tempTableOptions;
                        this.formData.fields[selectedFieldIndex].addFields = tempTableUserOptions;
                      }
                    });
                  }
                  // add the mode for each form component to display as preview
                  const formFields = [];
                  this.formData.fields.forEach(field => {
                    const formField = field;
                    formField.mode = "saved";
                    formFields.push(formField);
                  });
                  this.formData.fields = formFields;
                } else {
                  if (this.formResponses && this.formResponses.answers && this.formResponses.answers.length) {
                    this.formResponses.answers.forEach(resObj => {
                      const question = this.formData.activity.questions.find(question => question.id == resObj.questionId);

                      if (resObj) {
                        if (resObj.questionName === "MultiChoice" || resObj.questionName === "Image") {
                          question.answer = resObj.answerText;
                          const optionsIds = _.cloneDeep(resObj.optionsIds);
                          question.optionsIds = resObj.optionsIds ? optionsIds : [];

                          question.subType = resObj.subType;
                        } else if (resObj.questionName === "DateTime") {
                          question.answer = resObj.answerText;
                          question.date = resObj.date;
                          question.time = resObj.time;
                          question.dateFormat = resObj.dateFormat;
                          question.timeFormat = resObj.timeFormat;
                        } else if (resObj.questionName == "Boolean") {
                          question.answer = resObj.answerText;
                          question.answerId = resObj.answerId;
                        } else if (resObj.questionName == "Log") {
                          question.multiAnswer = _.cloneDeep(resObj.multiAnswer);
                          question.answerId = resObj.answerId;
                        } else if (resObj.questionName == "Index") {
                          question.answer = resObj.answerText;
                        } else if (resObj.questionName == "DropDown") {
                          question.answer = resObj.answerText;
                          question.optionId = resObj.optionId;
                          question.index = resObj.index;
                          question.answerId = resObj.answerId;
                        } else {
                          question.answer = resObj.answerText;
                        }
                        question.computedScore = resObj.score || 0;
                        question.actualScore = resObj.actualScore || 0;
                      } else {
                        question.answer = "";
                        if (question.type != "Section") {
                          question.computedScore = 0;
                          question.actualScore = 0;
                        }
                      }
                    });
                  }
                  activityService.setRequiredFieldsOnEachStep(this);
                }
                let responseScore = {};
                responseScore.totalScore = 0;
                responseScore.sectionScores = {};
                this.unscheduledForms.push({
                  form: this.formData,
                  response: {
                    answers: this.formResponses || [],
                    state: this.formResponses.state,
                    totalScore: responseScore.totalScore,
                    sectionScores: responseScore.sectionScores
                  }
                });
                this.navigateToOtherFormInAPacket(0);
              });
            });
          } else {
            this.getEDCUnscheduleFormDetails();
          }
        })
        .catch(error => {
          if (error && (error.message || error.body.message)) {
            this.$toastr.error(error.message || error.body.message);
          } else {
            this.$toastr.error("Unable to fetch the unscheduled packets");
          }
        });
    },

    // get the edc form data
    getEDCUnscheduleFormDetails() {
      this.selectedPacket.unscheduledForms.forEach(form => {
        if (form.type == "EDC") {
          this.$api.getEDCFormDataFact(form.formId, this.studyId).then(result => {
            this.formResponses = result.body.response || [];
            this.formData = result.body;
            this.formData.srNo = form.srNo;
            // send the saved answers to the corresponding form components
            if (this.formResponses && this.formResponses.answers && this.formResponses.answers.length) {
              // loop through the available answers
              this.formResponses.answers.forEach(answer => {
                // get the field index in the saved formData using answer question ID
                const selectedFieldIndex = findIndex(this.formData.fields, ["id", answer.questionId]);
                // get the option which is saved as answer using option ID
                const selectedOption = find(this.formData.fields[selectedFieldIndex].options, ["id", answer.optionId]);
                // get index of the option in options array which is saved as answer using optionnId
                const selectedOptionIndex = findIndex(this.formData.fields[selectedFieldIndex].options, ["id", answer.optionId]);
                // In formData attach answer as well as the comment if the comment message is saved
                this.formData.fields[selectedFieldIndex].answer = answer.answerText;
                // for singlechoice the answer which is saved
                // need's to be modified as per preview
                if (this.formData.fields[selectedFieldIndex].name === "formSinglechoice" || this.formData.fields[selectedFieldIndex].name === "formDropdown") {
                  this.formData.fields[selectedFieldIndex].answer = answer.optionId;
                }
                if (this.formData.fields[selectedFieldIndex].name === "formScale") {
                  const selectedScaleOption = find(this.formData.fields[selectedFieldIndex].options, ["id", answer.optionId]);
                  if (selectedScaleOption.type === "NA" || selectedScaleOption.type === "Other") {
                    this.formData.fields[selectedFieldIndex].nonScaleAnswer = answer.answerText;
                    this.formData.fields[selectedFieldIndex].answer = null;
                  }
                }
                if (selectedOption && selectedOption.type === "Other" && selectedOption.commentField) {
                  this.formData.fields[selectedFieldIndex].options[selectedOptionIndex].comment.commentMessage = answer.comment;
                }
                // for checkBox the options array which is saved
                // need's to be modified as per preview
                const tempOptions = [];
                if (this.formData.fields[selectedFieldIndex].name === "formCheckbox") {
                  this.formData.fields[selectedFieldIndex].options.forEach((option, index) => {
                    const tempOption = option;
                    tempOption.answer = { unSelected: `${index + 1}` };
                    tempOption.value = option.label;
                    tempOption.selectVal = `${index + 1}`;
                    tempOptions.push(option);
                  });
                  answer.multiAnswer.forEach(ans => {
                    tempOptions[ans.index].answer = {
                      selected: tempOptions[ans.index].selectVal
                    };
                    if (tempOptions[ans.index].type === "Other" && tempOptions[ans.index].commentField) {
                      tempOptions[ans.index].comment.commentMessage = ans.comment;
                    }
                  });
                  this.formData.fields[selectedFieldIndex].options = tempOptions;
                }
                if (this.formData.fields[selectedFieldIndex].name === "formDateTime") {
                  if (answer.time) {
                    if (this.formData.fields[selectedFieldIndex].timeField.format === "hh:mm a") {
                      const timeVals = answer.time.split(" ");
                      const time = timeVals[0].split(":");
                      this.formData.fields[selectedFieldIndex].time = {
                        hh: time[0],
                        mm: time[1]
                      };
                      this.formData.fields[selectedFieldIndex].meridian = timeVals[1] || null;
                    } else if (this.formData.fields[selectedFieldIndex].timeField.format === "HH:mm") {
                      const time = answer.time.split(":");
                      this.formData.fields[selectedFieldIndex].time = {
                        HH: time[0],
                        mm: time[1]
                      };
                    }
                    this.formData.fields[selectedFieldIndex].timezone = answer.timezone || null;
                  }
                  if (answer.date) {
                    const dateVals = answer.date.split("/");
                    const dateFormat = pull(uniq(this.formData.fields[selectedFieldIndex].dateField.format), "/");
                    dateFormat.forEach((value, index) => {
                      if (value === "M") {
                        this.formData.fields[selectedFieldIndex].month = dateVals[index];
                      }
                      if (value === "D") {
                        this.formData.fields[selectedFieldIndex].date = dateVals[index];
                      }
                      if (value === "Y") {
                        this.formData.fields[selectedFieldIndex].year = dateVals[index];
                      }
                    });
                  }
                }
                // for table the fields array which is saved need's to be modified as per preview
                const tempTableOptions = [];
                if (this.formData.fields[selectedFieldIndex].name === "formTable") {
                  // for the available fields add the answer which are configured at form creation
                  if (this.formData.fields[selectedFieldIndex].noOfFields) {
                    for (let ind = 0; ind < this.formData.fields[selectedFieldIndex].noOfFields; ind++) {
                      tempTableOptions.push({
                        index: ind,
                        type: "OPTION",
                        label: ""
                      });
                    }
                  }
                  // Add the answer to fields which are not configured
                  // while form creation but added by user
                  const tempTableUserOptions = [];
                  if (answer.multiAnswer.length > this.formData.fields[selectedFieldIndex].noOfFields) {
                    for (let ind = this.formData.fields[selectedFieldIndex].noOfFields; ind < answer.multiAnswer.length; ind++) {
                      tempTableUserOptions.push({
                        index: ind,
                        type: "OPTION",
                        label: ""
                      });
                    }
                  }

                  // attach answers to the generated fields and user added fields
                  answer.multiAnswer.forEach((ans, index) => {
                    if (index < this.formData.fields[selectedFieldIndex].noOfFields) {
                      tempTableOptions[index].label = ans.answerText;
                    }
                    if (index >= this.formData.fields[selectedFieldIndex].noOfFields) {
                      tempTableUserOptions[index - this.formData.fields[selectedFieldIndex].noOfFields].label = ans.answerText;
                    }
                  });
                  this.formData.fields[selectedFieldIndex].fields = tempTableOptions;
                  this.formData.fields[selectedFieldIndex].addFields = tempTableUserOptions;
                }
              });
            }
            // add the mode for each form component to display as preview
            const formFields = [];
            this.formData.fields.forEach(field => {
              const formField = field;
              formField.mode = "saved";
              formFields.push(formField);
            });
            this.formData.fields = formFields;
            this.unscheduledForms.push({
              form: this.formData,
              response: { answers: this.formResponses || [] }
            });
            this.unscheduledForms = sortBy(this.unscheduledForms, [o => o.form.srNo]);
            // checking user Permission for the first form
            this.navigateToOtherFormInAPacket(0);
          });
        } else {
          this.$api.getActivityFormDataV3(form.formId, this.studyId).then(response => {
            this.formResponses = response.body.response || [];
            this.formData = response.body;
            for (let i = 0, seq = 1; i < this.formData.activity.questions.length; i++) {
              if (this.formData.activity.questions[i].type != "Section") {
                this.formData.activity.questions[i].stepSequence = seq++;
              }
            }
            activityService.setRequiredFieldsOnEachStep(this);
            this.formData.srNo = form.srNo;
            this.unscheduledForms.push({
              form: this.formData,
              response: { answers: this.formResponses || [] }
            });
            this.unscheduledForms = sortBy(this.unscheduledForms, [o => o.form.srNo]);
            // checking user Permission for the first form
            this.navigateToOtherFormInAPacket(0);
          });
        }
      });
    },
    // cancel the form and goto participant details
    cancelForm() {
      this.$router.push({
        name: "participant-profile",
        params: { studyId: this.studyId, participantId: this.participantId }
      });
    },
    // validate data before sending it to backend ans save
    validateDataForOneForm(type, unscheduleForm, formIndex) {
      // this.buttonClicked = true;
      this.saveType = type;
      const currentEdcFormErrors = JSON.parse(window.localStorage.getItem("thread-edcFormErrors")) || [];
      const dateError = [];
      const notAnError = [];
      if (find(currentEdcFormErrors, ["time", true]) || find(currentEdcFormErrors, ["date", true])) {
        currentEdcFormErrors.forEach(error => {
          if (error.date === true || error.time === true) {
            dateError.push(error);
          }
        });
        unscheduleForm.form.fields.forEach(field => {
          if (field.name === "formDateTime") {
            if (!field.date && !field.month && !field.year && (isEmpty(field.time) || !field.time.h || !field.time.m) && !field.meridian && !field.timezone && field.required === true) {
              notAnError.push(field);
            }
          }
        });
      }
      if (this.saveType == "DRAFT" && (find(currentEdcFormErrors, ["time", true]) || find(currentEdcFormErrors, ["date", true])) && dateError.length !== notAnError.length) {
        this.formSubmitted = this.formSubmitted + 1;
        this.$toastr.error("Please correct the Date/Time fields error as per the requirement");
        this.buttonClicked = false;
      } else if (this.saveType == "SUBMITTED" && (find(currentEdcFormErrors, ["comment", true]) || find(currentEdcFormErrors, ["time", true]) || find(currentEdcFormErrors, ["date", true]))) {
        this.formSubmitted = this.formSubmitted + 1;
        this.$toastr.error("Please populate the fields per the requirement.");
        this.buttonClicked = false;
      } else {
        this.responses = [];
        let answersPreviouslySaved = [];
        // loop over entire forms array and generate the answers for each form
        // this.unscheduledForms.forEach((unscheduleForm, formIndex) => {
        // intialize answers as empty array if no answers
        if (unscheduleForm.response.answers) {
          answersPreviouslySaved = unscheduleForm.response.answers || [];
        }
        this.currentFormResoponse = [];
        // generate answers array
        if (unscheduleForm.form.type == "EDC") {
          unscheduleForm.form.fields.forEach(field => {
            this.unscheduledForms[formIndex].response.state = this.saveType;
            this.unscheduledForms[formIndex].response.answers = [];
            this.generateAnswerFormat(field.name, field, answersPreviouslySaved, formIndex);
          });
        } else {
          unscheduleForm.form.activity.questions.forEach(question => {
            this.unscheduledForms[formIndex].response.state = this.saveType;
            this.unscheduledForms[formIndex].response.answers = [];
            this.unansweredQuestions = [];
            activityService.generateActivityAnswerFormat(question, answersPreviouslySaved, this.currentFormResoponse, this.unansweredQuestions);
          });
        }
          //this code need to be removed once backend advanced scoring changes are removed
          let responseScore = {};
          responseScore.totalScore = 0;
          responseScore.sectionScores = {};
          if (this.formData.type != "EDC") {
              this.unscheduledForms[formIndex].response.totalScore = responseScore.totalScore;
              this.unscheduledForms[formIndex].response.sectionScores = responseScore.sectionScores;
          }
        // attach generated answers array to intialized answers array
        if (this.currentFormResoponse.length) {
          this.unscheduledForms[formIndex].response.answers = this.currentFormResoponse;
        }
        // });
        // loop over the unschedule forms to check whether the required fields are filled or not
        // this.unscheduledForms.forEach(unscheduleForm => {
        // get all required fields for each form
        if (unscheduleForm.form.type == "EDC") {
          const requiredFieldIds = unscheduleForm.form.fields.filter(field => field.required === true).map(field => field.id);
          // get all the answers filled for each form
          const answersIds = unscheduleForm.response.answers.map(answer => answer.questionId);

          if (difference(requiredFieldIds, answersIds).length && type === "SUBMITTED") {
            this.formSubmitted = this.formSubmitted + 1;
            this.formErrors.push({
              formId: unscheduleForm.form.id,
              formName: unscheduleForm.form.name,
              errorMsg: "Please fill all the required fields."
            });
          }
        } else {
          let requiredFieldIds = unscheduleForm.form.activity.questions.filter(question => !this.unsupportedQuestionType.includes(question.type) && question.isSkippable == false);
          requiredFieldIds = requiredFieldIds.map(question => {
            return question.id;
          });
          // get all the answers filled for each form
          const answersIds = unscheduleForm.response.answers
            .filter(o => o.answerText !== null || o.date !== null || o.time !== null || o.multiAnswer.length > 0)
            .map(answer => {
              return answer.questionId;
            });
          requiredFieldIds = this.letMakeOptionalToDisableFields(requiredFieldIds, formIndex);
          if (difference(requiredFieldIds, answersIds).length && type === "SUBMITTED" && unscheduleForm.form && unscheduleForm.form.activity && !unscheduleForm.form.activity.customClinRO) {
            this.formSubmitted = this.formSubmitted + 1;
            this.formErrors.push({
              formId: unscheduleForm.form.id,
              formName: unscheduleForm.form.name,
              errorMsg: "Please fill all the required fields."
            });
          }

          if (this.saveType !== "DRAFT") {
            unscheduleForm.form.activity.questions.forEach(question => {
              if (question.hasFieldError && unscheduleForm.form.activity && !unscheduleForm.form.activity.customClinRO) {
                this.formErrors.push({
                  formId: unscheduleForm.form.id,
                  formName: unscheduleForm.form.name,
                  errorMsg: "Please fill valid data"
                });
              }
            });
          }
        }
      }
    },
    validateDataAndSave(type) {
      this.formErrors = [];
      this.buttonClicked = true;
      this.saveType = type;
      this.showValidationMessage = true;
      this.validationCount = this.validationCount + 1;
      //CSSR form validation
      let isCSSRFormError;
      let baselineCSSRFormError;
      this.unscheduledForms.forEach(unscheduleForm => {
        if (unscheduleForm && unscheduleForm.form.activity && unscheduleForm.form.activity.customClinRO && this.saveType == "SUBMITTED") {
          if (unscheduleForm.form.activity.customView === "CSSRS_BASELINE") {
            this.validateCSSRFormErros = customClinroService.checkBaselineValidationConfiguration(unscheduleForm.form.activity);
            baselineCSSRFormError = this.validateCSSRFormErros && this.validateCSSRFormErros.questions.filter(question => question.hasFieldError);
          } else {
            this.validateCSSRFormErros = customClinroService.checkValidationConfiguration(unscheduleForm.form.activity);
            isCSSRFormError = this.validateCSSRFormErros && this.validateCSSRFormErros.questions.filter(question => question.hasFieldError);
          }
        }
      });
      if ((baselineCSSRFormError && baselineCSSRFormError.length > 0) || (isCSSRFormError && isCSSRFormError.length > 0)) {
        this.buttonClicked = false;
        this.$toastr.error(`Please complete all required fields.`);
        return;
      }

      if (this.saveType !== "DRAFT") {
        this.triggerValidation = !this.triggerValidation;
      }
      this.isSubmit = true;
      this.unscheduledForms.forEach((unscheduleForm, formIndex) => {
        if (unscheduleForm.form.type == "EDC") {
          if (unscheduleForm.form.fields.filter(item => item.isSkippable)) {
            this.validateDataForOneForm(this.saveType, unscheduleForm, formIndex);
          }
        } else {
          if (unscheduleForm.form.activity.questions.filter(item => item.isSkippable)) {
            this.validateDataForOneForm(this.saveType, unscheduleForm, formIndex);
          }
        }
      });

      if (this.formErrors.length) {
        this.$toastr.error(this.formErrors[0].errorMsg);
        this.buttonClicked = false;
      } else {
        const postData = {
          participantId: this.participantId,
          unscheduledPacketId: this.packetId,
          unscheduledPacketVersionId: this.selectedPacket.unscheduledVersionId,
          state: this.saveType,
          packetFormResponses: this.unscheduledForms,
          responseType: this.responseType,
          milestone: this.milestone,
          taskInstanceId: this.taskInstanceId
        };
        this.unscheduledForms.map(form => {
          const formData = form.response.answers;
          formData.map(ans => {
            if (ans.questionName == "Index" && ans.answerText == "") {
              ans.answerText = {};
            }
            if (ans.questionName == "Log" && ans.multiAnswer == undefined) {
              ans.multiAnswer = [];
            }
          });
        });

        if (this.saveType == "DRAFT") {
          const formStatus = this.checkInvalidDataFormErrors();
          this.buttonClicked = false;
          if (formStatus) {
            return false;
          }
        }

        if (this.saveType == "SUBMITTED" && this.valdateRequiredFields() === "requiredError") {
          this.$toastr.error(`Please complete all required fields.`);
          this.buttonClicked = false;
        } else if (this.saveType == "SUBMITTED" && this.valdateRequiredFields() === "invalidData") {
          this.$toastr.error(`Please fill valid data`);
          this.buttonClicked = false;
        } else if (this.unscheduledPacketResponseId !== "0") {
          this.buttonClicked = true;
          postData.unscheduledPacketResponseId = this.unscheduledPacketResponseId;
          postData.unscheduledPacketResponseVersionId = this.alreadySavedUnscheduleForms.unscheduledPacketResponseVersionId;
          postData.unscheduledPacketVersionId = this.alreadySavedUnscheduleForms.unscheduledPacketVersionId;
          if (this.formData.type == "EDC") {
            this.$api
              .updateEDCUnscheduleFormResponseFactV2(this.packetId, this.studyId, this.participantId, this.unscheduledPacketResponseId, postData)
              .then(response => {
                if (response.body.unscheduledPacketResponseId) {
                  this.setSuccessToastMessage(this.saveType);
                  // clear all the available errorflags from Vue store
                  this.clearEDCFormErrors();
                  this.saveType = "";
                  this.$router.push({
                    name: "participant-profile",
                    params: {
                      studyID: this.studyId,
                      participantId: this.participantId
                    }
                  });
                } else {
                  this.$toastr.error("Unable to submit your response, Please try again.");
                  this.buttonClicked = false;
                }
              })
              .catch(error => {
                if (error && (error.message || error.body.message)) {
                  this.$toastr.error(error.message || error.body.message || "Unable to submit your response, Please try again.");
                  this.buttonClicked = false;
                }
              });
          } else {
            this.$api
              .updateEDCUnscheduleFormResponseFactV3(this.packetId, this.studyId, this.participantId, this.unscheduledPacketResponseId, postData)
              .then(response => {
                if (response.body.unscheduledPacketResponseId) {
                  this.setSuccessToastMessage(this.saveType);
                  // clear all the available errorflags from Vue store
                  this.clearEDCFormErrors();
                  this.saveType = "";
                  this.$router.push({
                    name: "participant-profile",
                    params: {
                      studyID: this.studyId,
                      participantId: this.participantId
                    }
                  });
                } else {
                  this.$toastr.error("Unable to submit your response, Please try again.");
                  this.buttonClicked = false;
                }
              })
              .catch(error => {
                if (error && (error.message || error.body.message)) {
                  this.$toastr.error(error.message || error.body.message || "Unable to submit your response, Please try again.");
                  this.buttonClicked = false;
                }
              });
          }
        } else {
          if (this.formData.type == "EDC") {
            this.$api
              .postEDCUnscheduleFormResponseFactV2(this.packetId, this.studyId, this.participantId, postData)
              .then(response => {
                if (response.body.unscheduledPacketResponseId) {
                  this.setSuccessToastMessage(this.saveType);
                  // clear all the available errorflags from Vue store
                  this.clearEDCFormErrors();
                  const studyID = this.studyId;
                  this.saveType = "";
                  this.$router.push({
                    name: "participant-profile",
                    params: { studyID, participantId: this.participantId }
                  });
                } else {
                  this.$toastr.error("Unable to submit your response, Please try again.");
                  this.buttonClicked = false;
                }
              })
              .catch(error => {
                if (error && (error.message || error.body.message)) {
                  this.$toastr.error(error.message || error.body.message || "Unable to submit your response, Please try again.");
                  this.buttonClicked = false;
                }
              });
          } else {
            this.post_EDCUnscheduleFormResponseFactV3(postData);
          }
        }
      }
    },
    post_EDCUnscheduleFormResponseFactV3(postData) {
      this.$api
        .postEDCUnscheduleFormResponseFactV3(this.packetId, this.studyId, this.participantId, postData)
        .then(response => {
          const status = response.status;
          if (status === 207) {
            this.confirmationUnscheduleForm(postData);
          } else {
            this.setSuccessToastMessage(this.saveType);
            this.profileNavigate(status);
          }
        })
        .catch(error => {
          if (error && (error.message || error.body.message)) {
            this.$toastr.error(error.message || error.body.message || "Unable to submit your response, Please try again.");
            this.buttonClicked = false;
          }
        });
    },
    confirmationUnscheduleForm(postData) {
      this.$swal({
        title: `This form has already been saved and submitted. Submitting again will create an additional record.${`\n\n`}Would you like to resubmit?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4a4a4a",
        cancelButtonColor: "#1e8fe1",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          postData.allowAdditional = true;
          this.post_EDCUnscheduleFormResponseFactV3(postData);
        } else {
          this.buttonClicked = false;
        }
      });
    },
    profileNavigate(status) {
      if (status === 208) {
        this.$toastr.success("This form has already been saved and submitted.");
      }
      this.clearEDCFormErrors();
      const studyID = this.studyId;
      this.saveType = "";
      this.$router.push({
        name: "participant-profile",
        params: { studyID, participantId: this.participantId }
      });
    },
    checkInvalidDataFormErrors() {
      this.showValidationMessage = true;
      this.validationCount = this.validationCount + 1;
      this.triggerValidation = !this.triggerValidation;
      if (this.valdateRequiredFields() === "invalidData") {
        this.$toastr.error("Please fill Valid Data.");
        return true;
      }
    },
    setSuccessToastMessage(saveType) {
      if (saveType == "SUBMITTED") {
        this.$toastr.success("Record saved successfully.");
      }
      if (saveType == "DRAFT") {
        this.$toastr.success("Draft saved successfully.");
      }
    },
    // get answer format for the field given
    generateAnswerFormat(fieldName, field, answers) {
      switch (fieldName) {
        case "formDropdown": {
          if (field.answer) {
            const answerSelected = find(field.options, ["id", field.answer]);
            const isAnswerAlreadySaved = find(answers, ["questionId", field.id]);
            const dropDownResponse = {
              questionId: field.id,
              questionName: field.name,
              optionId: answerSelected.id,
              answerText: answerSelected.label,
              index: answerSelected.index,
              comment: ""
            };
            if (isAnswerAlreadySaved) {
              dropDownResponse.answerId = isAnswerAlreadySaved.answerId;
            }
            if (answerSelected.type === "Other" && answerSelected.commentField) {
              dropDownResponse.comment = answerSelected.comment.commentMessage;
            }
            this.currentFormResoponse.push(dropDownResponse);
          }
          break;
        }
        case "formCheckbox": {
          const checkBoxResponse = {
            questionId: field.id,
            questionName: field.name,
            multiAnswer: []
          };
          const areAnswersAlreadySaved = find(answers, ["questionId", field.id]);
          field.options.forEach(option => {
            if (option.answer && option.answer.selected) {
              const tempCheckBoxResponse = {
                optionId: option.id,
                answerText: option.label,
                index: option.index,
                comment: option.type === "Other" && option.commentField ? option.comment.commentMessage : ""
              };

              checkBoxResponse.multiAnswer.push(tempCheckBoxResponse);
            }
          });
          if (areAnswersAlreadySaved) {
            checkBoxResponse.answerId = areAnswersAlreadySaved.answerId;
          }
          if (checkBoxResponse.multiAnswer.length > 0) {
            this.currentFormResoponse.push(checkBoxResponse);
          }
          break;
        }
        case "formTextNumeric": {
          if (field.answer) {
            const isAnswerAlreadySaved = find(answers, ["questionId", field.id]);
            const textNumericResponse = {
              questionId: field.id,
              questionName: field.name,
              answerText: field.answer
            };
            if (isAnswerAlreadySaved) {
              textNumericResponse.answerId = isAnswerAlreadySaved.answerId;
            }
            this.currentFormResoponse.push(textNumericResponse);
          }
          break;
        }
        case "formSinglechoice": {
          if (field.answer) {
            const answerSelected = find(field.options, ["id", field.answer]);
            const isAnswerAlreadySaved = find(answers, ["questionId", field.id]);
            const singleChoiceResponse = {
              questionId: field.id,
              questionName: field.name,
              optionId: answerSelected.id,
              answerText: answerSelected.label,
              index: answerSelected.index,
              comment: ""
            };
            if (isAnswerAlreadySaved) {
              singleChoiceResponse.answerId = isAnswerAlreadySaved.answerId;
            }
            if (answerSelected.type === "Other" && answerSelected.commentField) {
              singleChoiceResponse.comment = answerSelected.comment.commentMessage;
            }
            this.currentFormResoponse.push(singleChoiceResponse);
          }
          break;
        }
        case "formScale": {
          if (field.answer && !field.nonScaleAnswer) {
            const answerSelected = find(field.options, ["label", field.answer]);
            const isAnswerAlreadySaved = find(answers, ["questionId", field.id]);
            const scaleResponse = {
              questionId: field.id,
              questionName: field.name,
              optionId: answerSelected.id,
              answerText: answerSelected.label,
              weight: answerSelected.weight,
              index: answerSelected.index
            };
            if (isAnswerAlreadySaved) {
              scaleResponse.answerId = isAnswerAlreadySaved.answerId;
            }
            if (answerSelected.type === "Other" && answerSelected.commentField) {
              scaleResponse.comment = answerSelected.comment.commentMessage;
            }
            this.currentFormResoponse.push(scaleResponse);
          }
          if (field.nonScaleAnswer) {
            const answerSelected = find(field.options, ["label", field.nonScaleAnswer]);
            const isAnswerAlreadySaved = find(answers, ["questionId", field.id]);
            const scaleResponse = {
              questionId: field.id,
              questionName: field.name,
              optionId: answerSelected.id,
              answerText: answerSelected.label,
              index: answerSelected.index
            };
            if (isAnswerAlreadySaved) {
              scaleResponse.answerId = isAnswerAlreadySaved.answerId;
            }
            if (answerSelected.type === "Other" && answerSelected.commentField) {
              scaleResponse.comment = answerSelected.comment.commentMessage;
            }
            this.currentFormResoponse.push(scaleResponse);
          }
          break;
        }
        case "formDateTime": {
          const isAnswerAlreadySaved = find(answers, ["questionId", field.id]);
          const dateTimeResponse = {
            questionId: field.id,
            questionName: field.name,
            timezone: field.timezone
          };
          if (isAnswerAlreadySaved) {
            dateTimeResponse.answerId = isAnswerAlreadySaved.answerId;
          }
          if (field.collectDate && field.dateField.format) {
            const dateFormat = pull(uniq(field.dateField.format), "/").join("");
            dateTimeResponse.date = "";
            dateFormat.split("").forEach(val => {
              if (val === "M" && field.month) {
                dateTimeResponse.date += `${field.month}/`;
              }
              if (val === "Y" && field.year) {
                dateTimeResponse.date += `${field.year}/`;
              }
              if (val === "D" && field.date) {
                dateTimeResponse.date += `${field.date}/`;
              }
            });
            if (dateTimeResponse.date.length > 0) {
              dateTimeResponse.date = dateTimeResponse.date.slice(0, -1);
            }
          }
          if (field.collectTime && field.timeField.format) {
            if (field.timeField.format === "hh:mm a" && field.time.hh && field.time.mm) {
              dateTimeResponse.time = `${field.time.hh}:${field.time.mm} ${field.meridian}`;
            }
            if (field.timeField.format === "HH:mm" && field.time.HH && field.time.mm) {
              dateTimeResponse.time = `${field.time.HH}:${field.time.mm}`;
            }
          }
          if ((dateTimeResponse.date && dateTimeResponse.date.length > 0) || (dateTimeResponse.time && dateTimeResponse.time.length > 0)) {
            dateTimeResponse.timezone = field.timezone;
            this.currentFormResoponse.push(dateTimeResponse);
          }
          break;
        }
        case "formTable": {
          const tableResponse = {
            questionId: field.id,
            questionName: field.name,
            multiAnswer: []
          };
          const areAnswersAlreadySaved = find(answers, ["questionId", field.id]);
          field.fields.forEach(option => {
            if (option.label) {
              tableResponse.multiAnswer.push({
                answerText: option.label
              });
            }
          });
          field.addFields.forEach(option => {
            if (option.label) {
              tableResponse.multiAnswer.push({
                answerText: option.label
              });
            }
          });
          if (areAnswersAlreadySaved) {
            tableResponse.answerId = areAnswersAlreadySaved.answerId;
          }
          if (tableResponse.multiAnswer.length > 0) {
            this.currentFormResoponse.push(tableResponse);
          }
          break;
        }
        case "formTextArea": {
          if (field.answer) {
            const isAnswerAlreadySaved = find(answers, ["questionId", field.id]);
            const textAreaResponse = {
              questionId: field.id,
              questionName: field.name,
              answerText: field.answer
            };
            if (isAnswerAlreadySaved) {
              textAreaResponse.answerId = isAnswerAlreadySaved.answerId;
            }
            this.currentFormResoponse.push(textAreaResponse);
          }
          break;
        }
        default:
          break;
      }
    },
    validateDataForScoring() {
      this.unscheduledForms[this.currentFormIndex].response.answers = [];
      let answersPreviouslySaved = [];
      if (this.unscheduledForms[this.currentFormIndex].response) {
        answersPreviouslySaved = this.unscheduledForms[this.currentFormIndex].response.answers || [];
      }
      if (this.unscheduledForms[this.currentFormIndex].form.type == "EDC") {
        this.unscheduledForms[this.currentFormIndex].form.fields.forEach(field => {
          this.generateAnswerFormat(field.name, field, answersPreviouslySaved);
        });
        this.unscheduledForms[this.currentFormIndex].form.fields.filter(field => field.required === true).map(field => field.id);
      } else {
        if (this.unscheduledForms[this.currentFormIndex].form) {
          this.unansweredQuestions = [];
          this.unscheduledForms[this.currentFormIndex].form.activity.questions.forEach(question => {
            activityService.generateActivityAnswerFormat(question, answersPreviouslySaved, this.unscheduledForms[this.currentFormIndex].response.answers, this.unansweredQuestions);
          });

          this.unscheduledForms[this.currentFormIndex].form.activity.questions.filter(question => question.type != "Section" && question.type != "SurveyCompletion" && question.isSkippable == false).map(question => question.id);

          //this code need to be removed once backend advanced scoring changes are removed
          let responseScore = {};
          responseScore.totalScore = 0;
          responseScore.sectionScores = {};
          this.responseScores[this.currentFormIndex] = responseScore;
          this.$set(this.responseScores, this.currentFormIndex, responseScore);
          this.unscheduledForms[this.currentFormIndex].response.totalScore = responseScore.totalScore;
          this.unscheduledForms[this.currentFormIndex].response.sectionScores = responseScore.sectionScores;
          //this code need to be removed once backend advanced scoring changes are removed
        }
      }
    },
    // update the flag from the form fields after the form submitted
    formSubmittedFlag(value) {
      this.formSubmitted = value;
    },
    toggleParticipant(participant) {
      this.$router.push({
        name: "study-participant-edc-unschedule-form-reskin",
        params: {
          studyId: this.studyId,
          participantId: this.participantId,
          packetId: this.packetId,
          unscheduledPacketResponseId: "0"
        }
      });
      this.participantId = participant.id;
      this.getParticipantDetails();
    },

    // METHODS ADDED FOR INTEGRATING FORMS CREATED FROM ACTIVITY CONFIGURATOR

    navigateToOtherFormInAPacket(formIndex) {
      /*this.validateDataForOneForm(
        "SUBMITTED",
        this.unscheduledForms[this.currentFormIndex]
      );*/
      // if (this.formErrors.length) {
      //   this.$toastr.error(this.formErrors[0] && this.formErrors[0].errorMsg);
      //   return;
      // }
      // this.currentFormIndex = formIndex;
      const formDetails = this.unscheduledForms[formIndex].form.activity;
      this.currentFormPermission = this.accessPermissions(formDetails);
      this.showActivity = this.currentFormPermission.canViewActivity;
      if (this.currentFormPermission.canViewActivity) {
        this.currentFormIndex = formIndex;
        if (this.unscheduledForms[formIndex].form.type !== "EDC") {
          this.$nextTick(() => this.$refs.activityFormPreview.refresh());
        }
      } else {
        this.currentFormIndex = formIndex;
        return;
      }
      if (this.isSubmit) {
        this.$nextTick(() => (this.triggerValidation = !this.triggerValidation));
      }
    },
    accessPermissions(formDetails) {
      let canViewActivity, canCompleteActivity, userRole;
      const currentRole = this.userAccess[0][0];
      switch (currentRole) {
        case "Pi":
          userRole = "Principal-Investigator";
          break;
        case "HomeHealth":
          userRole = "Home-Health";
          break;
        case "SubPi":
          userRole = "Sub-Investigator";
          break;
        case "StudyCoordinator":
          userRole = "Study-Coordinator";
          break;
        case "SiteDataLock":
          userRole = "Site-DataLock";
          break;
        case "Rater":
          userRole = "Rater";
          break;
        case "Cra":
          userRole = "CRA";
          break;
        case "CraUB":
          userRole = "CraUB";
          break;
        case "Dm":
          userRole = "Data-Management";
          break;
        case "CallCenter":
          userRole = "Call-Center";
          break;
        case "Quality":
          userRole = "Quality";
          break;
        case "Biostatistics":
          userRole = "Biostatistics";
          break;
        case "Interviewer":
          userRole = "Interviewer";
          break;
        case "Pharmacovigilance":
          userRole = "Pharmacovigilance";
          break;
        case "Support":
          userRole = "Support";
          break;
      }
      //in case the Study and Activity is old where permission is not implemented
      if (formDetails && formDetails.canViewBy && formDetails.completedBy) {
        if (this.canSupportAccess || this.canStudyAdminAccess) {
          canViewActivity = true;
          canCompleteActivity = false;
        } else {
          canViewActivity = formDetails.canViewBy.some(user => user == userRole);
          canCompleteActivity = formDetails.completedBy.some(user => user == userRole);
        }
      } else {
        canViewActivity = true;
        canCompleteActivity = true;
      }

      const permissions = {
        canViewActivity: canViewActivity,
        canCompleteActivity: canCompleteActivity
      };
      return permissions;
    },
    checkErrors() {
      this.showValidationMessage = true;
      this.validationCount = this.validationCount + 1;
      this.triggerValidation = !this.triggerValidation;
      if (this.valdateRequiredFields() === "requiredError") {
        this.$toastr.error("Please fill all the required fields.");
      } else if (this.valdateRequiredFields === "invalidData") {
        this.$toastr.error("Please fill Valid Data.");
      } else {
        this.navigateToOtherFormInAPacket(this.currentFormIndex + 1);
      }
    },
    valdateRequiredFields() {
      let hasError = "";
      const formsDisabledFields = this.formsDisabledFields[this.currentFormIndex];
      if (this.unscheduledForms) {
        const currentFormData = this.unscheduledForms[this.currentFormIndex];
        const formQuestions = currentFormData.form.activity ? currentFormData.form.activity.questions : [];
        formQuestions.map(question => {
          if (!question.isSkippable && question.type !== "SurveyCompletion" && formsDisabledFields && !formsDisabledFields[question.id]) {
            if (activityService.validateRequiredFields(question)) {
              hasError = "requiredError";
            }
          }
          if (question.isSkippable && question.type == "Log" && activityService.checkLogEntryEmptyAnswers(question) && !formsDisabledFields[question.id]) {
            hasError = "invalidData";
          }
        });
      }
      return hasError;
    },
    onValidateAnswer() {
      this.showValidationMessage = false;
    }
  },
  mounted() {
    // clear all the available errorflags from Vue store
    this.clearEDCFormErrors();

    this.getParticipantDetails();
    this.getEDCUnscheduledPacketForms();
  },
  watch: {
    getVideoCallStatus(isCallInProgress) {
      this.telehealthCallStatus = isCallInProgress;
    }
  },
  props: ["studyData"],
  computed: {
    allStudyLanguages() {
      if (this.studyData && this.studyData.language) {
        return this.studyData.language;
      }
      return [];
    },
    languages() {
      if (this.allStudyLanguages && this.allStudyLanguages instanceof Array && this.allStudyLanguages.length) {
        return this.allStudyLanguages;
      }
      return [];
    },
    ...mapGetters(["user", "getVideoCallStatus"]),
    userIsStudyAdmin() {
      return this.user.userRole === "StudyAdmin";
    },
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canCraAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    },
    canDmAccess() {
      this.$acl.change(`${DM}`);
      return this.$acl.check("userAccess");
    },
    canSiteDataLockAccess() {
      this.$acl.change(`${SITEDATALOCK}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    languageCulture() {
      return this.selectedLanguageCulture.includes("-") ? this.selectedLanguageCulture : this.selectedLanguageCulture.toLowerCase();
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/assets/variables.scss";
.study-particip-details-block {
  background-color: #fff;
  min-height: 600px;
  .participant-detail-section {
    background-color: #fff;
  }
}

.primaryBgColor {
  background-color: #1e8fe1;
}

.primaryBackGround {
  background-color: #ffffff !important;
  padding: 0px 0px 20px 0px !important;
  width: 100% !important;
}

.formBorder {
  border-bottom: 1.5px solid #e4e8eb;
  padding-bottom: 20px;
}

.pointerEventsNone {
  pointer-events: none;
}
.btn {
  padding: 10px 25px;
}

/deep/ .modal.show .modal-dialog {
  width: 400px !important;
}
.clear-float {
  clear: both;
}
.shadow {
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.06);
}
</style>
<style lang="scss">
#dropdown-1 .btn.btn-secondary.dropdown-toggle {
  background-color: #fff;
  border: none;
  color: #414a4a;
  font-size: 14px;
  padding-top: 5px;
  padding-left: 0;
}
#dropdown-1 .dropdown-menu.show {
  font-size: 14px;
}
@media (min-width: 320px) and (max-width: 768px) {
  .btn-1 {
    padding: 5px 10px !important;
  }
  .center-align-item {
    justify-content: center !important;
    padding-top: 20px !important;
  }
}
</style>
